import dark from './dark';

const secondary = (params) => dark(params, true);

export default secondary;
